import PageLayout from "../../layouts/PageLayout"
import VehicleDetailPage from "./components/VehicleDetailPage"

const VehicleDetail = () => (
    <PageLayout>
        <VehicleDetailPage />
    </PageLayout>
)

export default VehicleDetail
